

import {DateTime, Duration, Interval} from "luxon";
import store from '../store';

const calculateRentenbeginn =(geburtsdatum, rentenbeginnAlter) => {
    const addMonths = geburtsdatum.day > 1 ? 1 : 0;
    return geburtsdatum.plus({ years: rentenbeginnAlter, months: addMonths }).set({ day: 1 });
};

const getMonths = function(start, end) {
    let duration = Interval.fromDateTimes(start, end);

    return duration.toDuration("months").toObject();
}


export const calculateInterest = (dates) => {
    let data = [];
    const r = store.getters['interestRate'];
    const d = DateTime.fromISO(store.getters['getCalculationDate']);
    const mode = store.getters["getMode"];
    const today = DateTime.fromJSDate(new Date());
    let duration = Interval.fromDateTimes(d, today);

    const p = 1;

    // Berechnung des Zinses erfolgt monatlich. Dies erfolgt in Anlehnung an die IUL, welche ebenfalls monatlich rechnet
    switch (mode) {

        case 'rate':

            const m_sum = parseFloat(store.getters["getAmount"]);

            const qm = 1 + ((Math.pow(1+r/100, 1/12) - 1) * 100) /100; // Einfacher wäre 1/12 des Jahreszins
            /**
             * Annahmen
             * r * q * (qn-1) / (q-1) r:monatliche rate, n monate q monatszinsfaktor
             *
             * monatszinsfaktor 1+(Monatlicher Zinssatz/100)
             *
             * monatlicher zins  100 * ( 12√ 1 + Jahreszins / 100 - 1)
             */
            data = dates.map((date)=> {

               let months = getMonths(d, date);

               if (months.months === 0) {
                return m_sum;
               }

               let factor = Math.pow(qm, months.months);

               let sum = m_sum * qm * (factor-1) / (qm -1);

               return sum.toFixed(2) ;
            });


            break;
        case 'single':
            let amount = parseFloat(store.getters["getAmount"]);

            /**
             const j=30;           Jahre
             const perioden =1;    Mögliche Zinsperioden 1 bedeutet jährlich
             const r = 3;          Zinssatz
             const k0 = 5000;      // Anfangskapital

             const kapital = k0 * Math.pow( (r/perioden/100) + 1, j * perioden);
             https://www.zinsen-berechnen.de/zinsformeln/unterjaehriger-zinseszins.php
             */

            data = dates.map((date) => {
                let months = getMonths(d, date);
                let years = (months.months / 12).toFixed(2);
                //let z = (amount * r * months.months) / (100 * 12);
                let z =  amount * Math.pow( (r/p/100) + 1, years * p);
                return z.toFixed(2);
            });

        break;

        default:
            //
        break;

    }

    return data
};


const beitragsregel = (start, rentenbeginn) => {
    const mode = store.getters["getMode"];
    const amount = store.getters["getAmount"];

    if (mode === "rate") {

        return [{
                "beitrag": amount,
                "beitragsart": {
                "laufendEinheit": "m",
                "laufendWert": 1
                },
                "zeitraum": {
                    "bis": rentenbeginn,
                    "von": start
                },
            "beitragsdynamik": null
        }]
    }

    if (mode === "single") {

        return [{
            "beitrag": amount,
            "beitragsart": {
            "einmaligDatum": start
            },
            "beitragsdynamik": null,
            "zeitraum": null
            }]
        }
}


export const calculationPayload = () => {

    const startdate = store.getters["getCalculationDate"];

    const dob = store.getters["getCalculationDOB"];

    let rentenbeginn = calculateRentenbeginn(dob, process.env.VUE_APP_RENTENBEGINNALTER);
        rentenbeginn = rentenbeginn.toFormat("yyyy-LL-dd");

    return {
        basiswerte: {
            tarifierung: {
                "versicherungsbeginn": startdate,
                "rentenbeginn_datum": rentenbeginn,
                "produktart": process.env.VUE_APP_PRODUKTART,
                "produktvariante": process.env.VUE_APP_PRODUKTVARIANTE,
                "iposnummer": null,
                "vermittlernummer": process.env.VUE_APP_VERMITTLER,
                "version": -1,
                "tarifkuerzel": null,
                "modifikation": null,
                "extraFieldsId": null,
                "partnerdatenTemplateId": null,
                "validateIntoPast": false       // Prüfung des Versicherungsbeginns erfolgt nicht
            },
            vp: {
                "geburtsdatum": dob.toFormat("yyyy-LL-dd"),
                "name": null,
                "vorname": null,
                "geschlecht": null
            }
        },
        rente: {
            beitragsregeln:  beitragsregel(startdate, rentenbeginn),
            modus: 'BEITRAG',
            rentenbeginn: rentenbeginn
        },

        pflege: null,
        roboAdvisor: null,
        todesfallschutz: null,
        vertragsschutz: null,

    };
}

export const calculateTodayPos =(axis) => {

    let today = DateTime.fromJSDate(new Date());

    let ticks = axis["_labelItems"];

    // Welcher Zeitraum wird hier in Monaten abgebildet?

    if (axis.min === undefined || axis.max === undefined) {
        return 0
    }

    let startIntv = DateTime.fromFormat(axis.min, 'dd.MM.yyyy', {locale: 'de'});
    let endIntv =   DateTime.fromFormat(axis.max, 'dd.MM.yyyy', {locale: 'de'})

    let maxPixel = ticks[ticks.length - 1].x;
    let minPixel = ticks[0].x;
    let offsetPixel = minPixel;

    let months = getMonths(startIntv, endIntv);
    // Breite durch Anzahl der Monate
    let pixelPerMonth = (maxPixel - minPixel) / months.months;

    return getMonths(startIntv, today).months * pixelPerMonth + offsetPixel ;

}
